import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { EMPTY_MOVEMENT_PATTERN_DTL_ENTITY, MovementPatternDtlEntity } from "domain/entity/MovementPattern/MovementPatternDtlEntity";
import { EMPTY_MOVEMENT_PATTERN_ENTITY, MovementPatternEntity, } from "domain/entity/MovementPattern/MovementPatternEntity";
import { CompanyRepository } from "domain/repository/Company/CompanyRepo";
import { MovementPatternRepository } from "domain/repository/MovementPattern/MovementPatternRepo";
import { ParameterDetailRepository } from "domain/repository/parameter/ParameterDetailRepo";
import _ from "lodash";
import { rcTypeDropdownOption, statusDropdownOptions } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { createMovementPatternDtlValidationSchema, createMovementPatternValidationSchema } from "presentation/constant/MovementPattern/MovementPatternValidationSchema";
import { ParameterCodeValue } from "presentation/constant/Parameter/ParameterCodeValue";
import { Validation } from "presentation/constant/Validation";
import { MovementPatternModel } from "presentation/model/MovementPattern/MovementPatternModel";
import { Dispatch, SetStateAction } from "react";
import { IFieldValue } from "veronica-ui-component/dist/component/core";
import BaseViewModel from "../BaseViewModel";

interface MovementPatternVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<MovementPatternModel>> | ((value: SetStateAction<MovementPatternModel>) => void),
    ],
    movementPatternRepo: MovementPatternRepository,
    parameterDetailRepo: ParameterDetailRepository,
    companyRepo: CompanyRepository,
}

export const MovementPatternVM = ({ dispatch, movementPatternRepo, parameterDetailRepo, companyRepo
}: MovementPatternVMProps) => {
    const [movementPatternDispatch] = dispatch;

    const loadDropdownOption = async () => {



        await parameterDetailRepo.getAllParameterDtlsByParameterCode(ParameterCodeValue.MOVEMENT_IND).then(
            parDtls => {
                if (parDtls) {
                    let newParDtls = _.orderBy(parDtls, ["parameterDtlCode"]);
                    const moveIndDropdownOption = newParDtls?.map((parDtl) => ({
                        dropdownLabel: parDtl.parameterDtlCode,
                        tagLabel: parDtl.parameterDtlCode,
                        value: parDtl.parameterDtlCode,
                    })) ?? []

                    movementPatternDispatch(prevState => ({
                        ...prevState,
                        dynamicOptions: {
                            ...prevState.dynamicOptions,
                            moveIndDropdownOptions: moveIndDropdownOption
                        }
                    }))
                }
            }
        )
        await companyRepo.getAllCompanyForCombobox().then(
            companies => {
                let companyCodeDropdownOption = companies?.filter(company => company.companyType !== 'ALLIANCE' && company.companyType !== 'MASTER')?.map((company) => ({
                    dropdownLabel: company.companyCode,
                    tagLabel: company.companyCode,
                    value: company.companyCode,
                })) ?? []
                companyCodeDropdownOption = _.orderBy(companyCodeDropdownOption, "dropdownLabel");

                movementPatternDispatch(prevState => ({
                    ...prevState,
                    dynamicOptions: {
                        ...prevState.dynamicOptions,
                        companyCodeDropdownOptions: companyCodeDropdownOption,
                    }
                }))
            }
        )

    }

    const searchMovementPatternDtlList = async (id: number) => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                tempDtlRows: [],
            }
        })
        await movementPatternRepo.searchMovementPatternDtlList(id).then(data => {
            if (data) {
                movementPatternDispatch(prevState => {
                    return {
                        ...prevState,
                        tempDtlRows: data,
                        currentEditRow: {
                            ...prevState.currentEditRow,
                            movementDetails: data,
                        },
                        currentRow: {
                            ...prevState.currentRow,
                            movementDetails: data,
                        },
                    }
                })
            }
        })
    }
    const showMovementPatternDtlListAfterSort = async (allRows: any[]) => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                tempDtlRows: allRows,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    movementDetails: allRows,
                },
                currentRow: {
                    ...prevState.currentRow,
                    //movementDetails: allRows,
                },
                dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }
    const searchAllMovementPatternList = async () => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentRow: { ...EMPTY_MOVEMENT_PATTERN_ENTITY },
                currentEditRow: { ...EMPTY_MOVEMENT_PATTERN_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                updatedRows: [],
                movementPatternList: [],
                currentDtlEditRow: { ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY },
                tempDtlRows: [],
            }
        })
        await movementPatternRepo.searchAllMovementPatternList().then(data => {
            if (data) {
                movementPatternDispatch(prevState => {
                    return {
                        ...prevState,
                        movementPatternList: data,
                    }
                })
            } else {
                movementPatternDispatch(prevState => {
                    return {
                        ...prevState,
                        movementPatternList: [],
                    }
                })
            }
        })
    }

    const onRowDrag = (rows: MovementPatternEntity[]) => {
        movementPatternDispatch(prevState => {
            const prevRows = prevState.movementPatternList;
            const toChangedRows = rows.map((e, index) => ({ ...e, tempPriority: prevRows[index].priority })).filter(e => e.tempPriority !== e.priority);

            return ({
                ...prevState,
                movementPatternList: rows,
                updatedRows: toChangedRows,
            })
        })
    }

    const onApply = async (updatedRows: MovementPatternEntity[]) => {

        return await movementPatternRepo.onApply(updatedRows);
    }

    const onDtlApply = async (updatedRows: MovementPatternDtlEntity[]) => {

        return await movementPatternRepo.onDtlApply(updatedRows);
    }

    const updateSelectedRows = async (rows: MovementPatternEntity[]) => {

        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                // movementPatternList: [...allRows],
                selectedRows: rows,
                forceRefresh: !prevState.forceRefresh
            }
        })
    }

    const updateSelectedDtlRows = async (updatedRows: MovementPatternDtlEntity[]) => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                selectedDtlRows: updatedRows,
                // currentDtlEditRow: updatedRows.length === 1 ? updatedRows[0] : { ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY },
                //dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }

    const onHeaderFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onDtlFieldChange = async (fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
        let val: any = fieldValue;
        if (_.isArray(val)) {
            val = _.uniq(val?.map((item: any) => item.value || item.key));
        }
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: {
                    ...prevState.currentDtlEditRow,
                    [fieldKey]: val,
                },
                masterState: {
                    ...prevState.masterState,
                    allFormState: {
                        ...prevState.masterState.allFormState,
                        [fieldKey]: ''
                    },
                }
            }
        })
    }

    const onRowDoubleClick = async (entity: MovementPatternEntity) => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                // currentEditRow: entity,
                currentRow: entity,
                tempDtlRows: entity.movementDetails ?? [],
                isShowEditPanel: true,
            }
        })
    }

    const onDtlRowDoubleClick = async (entity: MovementPatternDtlEntity) => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: entity,
                isShowDtlEditPanel: true,
            }
        })
    }

    const onDtlDtlDeleteClick = async (entitys: MovementPatternDtlEntity[]) => {
        movementPatternDispatch(prevState => {
            let dtls = prevState.tempDtlRows?.slice();
            const newDtls = dtls.filter(a => !entitys?.some(b => {
                if (!b.id) {
                    return b.tempKey === a.tempKey;
                } else {
                    return b.id === a.id;
                }
            }));
            return {
                ...prevState,
                selectedDtlRows: [],
                currentEditRow: {
                    ...prevState.currentEditRow,
                    movementDetails: newDtls,
                },
                tempDtlRows: newDtls,
                dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }

    const onDtlAddRowClick = async () => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: {
                    ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY,
                    tempKey: _.uniqueId(),
                    cntrStatus: statusDropdownOptions[0]?.value ?? '',
                    movementCode: prevState.dynamicOptions.moveIndDropdownOptions.length > 0 ? prevState.dynamicOptions.moveIndDropdownOptions[0].value : ''
                },
                isShowDtlAddPanel: true,
            }
        })
    }

    const onCloseEidtPanel = async () => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: { ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY },
                tempDtlRows: [],
                currentEditRow: { ...EMPTY_MOVEMENT_PATTERN_ENTITY },
                isShowEditPanel: false,
                isAdd: false,
                isEdit: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onCloseDtlEidtPanel = async () => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: { ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY },
                isShowDtlAddPanel: false,
                isShowDtlEditPanel: false,
                masterState: {
                    ...prevState.masterState,
                    allFormState: {},
                }
            }
        })
    }

    const onSave = async (currentRow: MovementPatternEntity) => {

        const valResult = await Validation(createMovementPatternValidationSchema).ValidateFormOnly(currentRow);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            movementPatternDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            const res: ResponseEntity = {
                code: "",
                success: false,
                msg: null,
                data: null
            }

            return res;
        }
        return movementPatternRepo.onSave(currentRow);
    }

    const onSaveClicked = () => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                masterState: {
                    ...prevState.masterState,
                    isSaveClicked: true,
                    allFormState: {},
                }
            }
        })
    }

    const onAddClick = async () => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...EMPTY_MOVEMENT_PATTERN_ENTITY,
                    patternType: rcTypeDropdownOption[0]?.value ?? ''
                },
                isShowEditPanel: true,
                isAdd: true,
            }
        })
    }

    const onDtlTempSave = async (dtlEditRow: MovementPatternDtlEntity) => {
        const valResult = await Validation(createMovementPatternDtlValidationSchema).ValidateFormOnly(dtlEditRow);
        let validatedResult: { [x: string]: string } = {};
        if (valResult) {
            validatedResult = { ...valResult };

            movementPatternDispatch(prevState => {
                return {
                    ...prevState,
                    masterState: {
                        ...prevState.masterState,
                        allFormState: {
                            ...validatedResult
                        },
                    }
                }
            });

            return;
        }

        movementPatternDispatch(prevState => {
            let newDtls = prevState.tempDtlRows?.slice();
            let existingDtlIndex = newDtls?.findIndex(dtl => {
                if (dtl.id) {
                    return dtl.id === dtlEditRow.id
                } else {
                    return dtl.tempKey === dtlEditRow.tempKey
                }

            });
            if (existingDtlIndex !== -1) {
                Object.assign(newDtls[existingDtlIndex], dtlEditRow);
            } else {
                newDtls.push(dtlEditRow);
            }
            return {
                ...prevState,
                tempDtlRows: newDtls,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    movementDetails: newDtls,
                },
                currentDtlEditRow: { ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY },
                isShowDtlEditPanel: false,
                isShowDtlAddPanel: false,
                dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }
    const onResetClick = async (isAdd: boolean) => {

        movementPatternDispatch(prevState => {
            //const details = prevState.currentRow.movementDetails ?? [];
            //const sortedDetails = [...details].sort((a, b) => (a.tempSeq ?? 0) - (b.tempSeq ?? 0));
            return {
                ...prevState,
                currentEditRow: isAdd ? { ...EMPTY_MOVEMENT_PATTERN_ENTITY } : prevState.currentRow,
                tempDtlRows: isAdd ? [] : prevState.currentRow.movementDetails,
                isShowDtlEditPanel: false,
                isShowDtlAddPanel: false,
                currentDtlEditRow: { ...EMPTY_MOVEMENT_PATTERN_DTL_ENTITY },
                dtlForceRefresh: !prevState.dtlForceRefresh
            }
        })
    }
    const onEditClick = async () => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                isEdit: true,
                currentEditRow: prevState.currentRow,
            }
        })
    }

    const onCheckboxChange = (checked: boolean, fieldName: string) => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentEditRow: {
                    ...prevState.currentEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }
    const onDtlCheckboxChange = (checked: boolean, fieldName: string) => {
        movementPatternDispatch(prevState => {
            return {
                ...prevState,
                currentDtlEditRow: {
                    ...prevState.currentDtlEditRow,
                    [fieldName]: checked ? "Y" : "N",
                },
            }
        })
    }

    return {
        onDtlCheckboxChange: onDtlCheckboxChange,
        onResetClick: onResetClick,
        onCheckboxChange: onCheckboxChange,
        onDtlDtlDeleteClick: onDtlDtlDeleteClick,
        onEditClick: onEditClick,
        onDtlTempSave: onDtlTempSave,
        onCloseDtlEidtPanel: onCloseDtlEidtPanel,
        onDtlAddRowClick: onDtlAddRowClick,
        onDtlRowDoubleClick: onDtlRowDoubleClick,
        onDtlFieldChange: onDtlFieldChange,
        onAddClick: onAddClick,
        onSave: onSave,
        onCloseEidtPanel: onCloseEidtPanel,
        onRowDoubleClick: onRowDoubleClick,
        onHeaderFieldChange: onHeaderFieldChange,
        updateSelectedRows: updateSelectedRows,
        updateSelectedDtlRows: updateSelectedDtlRows,
        onApply: onApply,
        onDtlApply: onDtlApply,
        onRowDrag: onRowDrag,
        loadDropdownOption: loadDropdownOption,
        searchAllMovementPatternList: searchAllMovementPatternList,
        searchMovementPatternDtlList: searchMovementPatternDtlList,
        showMovementPatternDtlListAfterSort: showMovementPatternDtlListAfterSort,
        onSaveClicked: onSaveClicked,
    }
}